export enum EnumRelativeDates {
  YESTERDAY = 'yesterday',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  LAST7DAYS = '7 days ago',
  LAST30DAYS = '30 days ago',
  NEXT7DAYS = '7 days from now',
  NEXT30DAYS = '30 days from now'
}
